import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import { EnvService } from '../env.service';
import { WeavyChatService } from '../weavy-chat.service';

@Component({
  selector: 'app-chat-list',
  templateUrl: './chat-list.component.html',
  styleUrls: ['./chat-list.component.scss'],
})
export class ChatListComponent implements OnInit {

  public conversations: any[] = [];
  public chatType = 'chat-room';
  public unreadChatCount;
  public unreadDmCount;
  currentUser: any;
  public dmImageSrc = 'assets/images/user-dm-profile.png';

  constructor(private weavyService: WeavyChatService, private router: Router,
    private loadingCtrl: LoadingController, public envService: EnvService) { }

  ngOnInit() {
    this.showLoader();
    this.currentUser = JSON.parse(localStorage.getItem('pToken'));
    this.weavyService.getAllConversations().then(async (response)=>{
      let conversations = await response.json();
      if(conversations && conversations['data'] && conversations['data'].length > 0){
         this.unreadChatCount = 0;
         this.unreadDmCount = 0;
         this.conversations = this.parseConversations(conversations['data']);
      } 
      this.hideLoader();
    });
    if(this.currentUser && this.currentUser.user){
      let name = this.currentUser.user['first_name']+' '+(this.currentUser.user['last_name'] ? this.currentUser.user['last_name'].charAt(0) : '');
      this.weavyService.syncUserName(name, this.getImagePath(this.currentUser.user['id']), 'promoga_user_'+this.currentUser.user['id']);
    } 
  }

  parseConversations(conversations){
      conversations.map((conversation)=>{
        if(conversation['uid'] && conversation.uid.startsWith('promoga_chat_room_')){
          conversation['chatType'] = 'chat-room';
          this.unreadChatCount = conversation.is_unread ? this.unreadChatCount+1: this.unreadChatCount;
          conversation = this.getDpForChatRoom(conversation);
        } else if(conversation['uid'] && conversation.uid.startsWith('promoga_chat_dm_')){
          conversation['chatType'] = 'dm';
          this.unreadDmCount = conversation.is_unread ? this.unreadDmCount+1: this.unreadDmCount;
          conversation = this.getNameAndDpForDm(conversation);
        }
      });
      return conversations;
  }

  //For dm we get both users name in displayname from weavy- here converting it to the respective user name
  getNameAndDpForDm(conversation){
    let userIds = conversation.uid.replace('promoga_chat_dm_','').split('_');
    let userNames = conversation.display_name.split(',');
    if(userIds && userIds.length == 2 && userNames && userNames.length == 2){
       userIds.map((userId, index)=>{
          if(this.currentUser && this.currentUser.user && this.currentUser.user.id != userId){
             conversation['display_name'] = userNames[index];
             let paddedId = userId.toString().padStart(12, '0').match(/.{1,3}/g);
             conversation['avatarUrl'] = this.envService.BASE_URL+'_collection/users/'+paddedId.join('/')+'/50x50.jpeg';
          } 
       });
    }
    return conversation;
  }

  getDpForChatRoom(conversation){
    let userId = conversation.uid.replace('promoga_chat_room_','');
    let paddedId = userId.toString().padStart(12, '0').match(/.{1,3}/g);
    conversation['avatarUrl'] = this.envService.BASE_URL+'_collection/users/'+paddedId.join('/')+'/50x50.jpeg';
    return conversation;
  }

  onDmImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.dmImageSrc;
  }

  gotoChatRoom(roomId){
     if(roomId){
        this.router.navigate(['/chat/'+roomId]);
     }
  }

  showLoader() {
    this.loadingCtrl.create({
        message: 'Loading...'
    }).then((res) => {
        res.present();

        res.onDidDismiss().then((dis) => {
            this.hideLoader();
        });
    });
}

hideLoader() {
    setTimeout(() => {
        this.loadingCtrl.dismiss();
    }, 1000);
}

getImagePath(userId){
  let paddedId = userId.toString().padStart(12, '0').match(/.{1,3}/g);
  return this.envService.BASE_URL+'_collection/users/'+paddedId.join('/')+'/50x50.jpeg';
}

}
